export default "__VITE_ASSET__CHLtC$5Z__"